export const PRIMARY = '#960000';
export const WHITE = '#FFFFFF';
export const PLACEHOLDER = '#B0B0B0';
export const RED = '#ef5657';
